import { TextInput as MantineTextInput, TextInputProps } from '@mantine/core'
import styles from './TextInput.module.scss'
import cn from 'classnames'
import { v4 as uuidv4 } from 'uuid'
import { useState } from 'react'

interface ITextInput extends TextInputProps {
   shouldLeftSectionBeFocused?: boolean
}

export const TextInput = ({
   id,
   onBlur,
   onFocus,
   leftSection,
   shouldLeftSectionBeFocused = false,
   ...rest
}: ITextInput) => {
   const [isFocused, setIsFocused] = useState(false)

   return (
      <MantineTextInput
         classNames={{
            input: cn(styles['text-input']),
            label: 'text-white/90 font-medium mb-1.5',
            description: 'pt-0.5',
         }}
         leftSection={
            leftSection && (
               <div
                  className={cn({
                     'text-[#a684ff]': shouldLeftSectionBeFocused && isFocused,
                  })}
               >
                  {leftSection}
               </div>
            )
         }
         inputWrapperOrder={['label', 'input', 'description', 'error']}
         styles={{}}
         onFocus={(e) => {
            setIsFocused(true)
            onFocus?.(e)
         }}
         onBlur={(e) => {
            setIsFocused(false)
            onBlur?.(e)
         }}
         id={id || uuidv4()}
         {...rest}
      />
   )
}
